/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author ILya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { EInputKind } from '@components/common/Input/Input';
import type { ITableFilterMultiSelect } from '@modules/table';

export const filterMsisdnSearchInputType = (maxLength?: number): ITableFilterMultiSelect['searchInputTypeCallback'] => {
	if (!maxLength) return undefined;

	return (searchValue) => (searchValue.length > maxLength ? EInputKind.error : EInputKind.normal);
};
